<template>
  <div class="courseware_learning_wrap">
    <div class="courseware_learning_title">
      <span style="margin-left:24px">我的得分：<b>{{coursewareScore}}</b></span>
      <i> - </i>
      <span>当前课程进度：<b>{{Math.ceil(courseProgress)}}</b>%（完成任务数{{coursewareFinishCount}}个/总任务数{{coursewareSumCount}}个）</span>
      <span style="margin-left:24px">课件学习成绩 =（完成课件任务数/课件总任务数）*100*课件学习权重</span>
    </div>
    <div class="courseware_learning_chapter">
      <!-- <div v-for="(item, i) in treeData" :key="item.id"> -->
        <!-- <h2>NO.{{i+1}} {{item.catalogName}}</h2> -->
        <el-table
          border
          ref="multipleTable"
          :data="treeData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{ background: '#E8F2FF', color: '#606266' }"
          :cell-style="changeCellStyle"
        >
          <el-table-column label="章节" align="center">
            <template slot-scope="scope">
              <div style="text-align: left; margin-left:40px">
                <img src="../../../../../../../static/images/study/icon/numIcon.png" alt="" v-if="scope.row.level==0" class="level_zero_img">
                <span v-if="scope.row.num" class="level_zero_num">NO.{{ scope.row.num }} </span>
                <span v-if="scope.row.level==0" class="level_zero">{{ scope.row.catalogName }}</span>
                <span v-if="scope.row.level==1" class="level_one">{{ scope.row.catalogName }}</span>
                <span v-if="scope.row.level==2" class="level_two">{{ scope.row.catalogName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="资源" align="center">
            <template slot-scope="scope">
              <ul class="source_list" v-if="scope.row.resourceDtos.length>0">
                <li v-for="val in scope.row.resourceDtos" :key="val.id">
                  <img src="../../../../../../../static/images/picture.png" alt="" v-if="val.resourceType==1&&val.type==1||val.resourceType==5&&val.type==1">
                  <img src="../../../../../../../static/images/wenjian.png" alt="" v-else-if="val.resourceType==1&&val.type==2||val.resourceType==5&&val.type==2">
                  <img src="../../../../../../../static/images/yinpin.png" alt="" v-else-if="val.resourceType==1&&val.type==3||val.resourceType==5&&val.type==3">
                  <img src="../../../../../../../static/images/video.png" alt="" v-else-if="val.resourceType==1&&val.type==4||val.resourceType==5&&val.type==4">
                  <img src="../../../../../../../static/images/zip.png" alt="" v-else-if="val.resourceType==1&&val.type==5||val.resourceType==5&&val.type==5">                
                  <img src="../../../../../../../static/images/ti.png"alt="" v-else-if="val.resourceType==3">
                  <img src="../../../../../../../static/images/shijuan.png"alt="" v-else-if="val.resourceType==5">
                  <!-- <span :title="val.name">{{val.name}}</span> -->
                   <span :title="val.name" v-if="val.resourceType==1">{{val.name}}</span>
                  <span :title="val.name" v-if="val.resourceType==3">{{val.name?val.name:'实操题'+val.id}}</span>
                  <span :title="val.name" v-if="val.resourceType==5">{{val.name}}</span>
                </li>
              </ul>
              <ul class="source_list" v-else>
                <li style="justify-content: center;padding-left:0">--</li>
              </ul>
            </template>
          </el-table-column>
           <el-table-column label="进度" align="center">
            <template slot-scope="scope">
              <ul class="progress_list" v-if="scope.row.resourceDtos.length>0">
                 <li v-for="val in scope.row.resourceDtos" :key="val.id">
                    <div v-if="val.taskType==0">
                      <!-- <img src="../../../../../../../static/images/study/icon/inProgress.png" alt="">
                      <span style="color: #FFB23C;margin-left: 4px">进行中</span> -->
                       <span style="color: #FFFFFF;margin-left: 4px">-</span>                  
                    </div>
                   <div v-if="val.taskType==1">
                       <div v-if="val.isFinish=='1'">
                          <img src="../../../../../../../static/images/study/icon/completed.png" alt="">
                          <span style="color: #5397F7;margin-left: 4px">已完成</span>
                       </div>
                      <div v-else>
                          <img src="../../../../../../../static/images/study/icon/inProgress.png" alt=""> 
                          <span style="color: #FFB23C;margin-left: 4px">进行中</span>                   
                      </div>                
                  </div>
                </li>
              </ul>
              <ul class="progress_list" v-else>
                <li>--</li>
              </ul>
            </template>
          </el-table-column>
        </el-table>
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import * as api from "../../../../../../api/achievementApi";
export default {
  props: ['courseId', 'userId' ,'classId'],
  data() {
    return {
      treeData: [],
      courseProgress: '',
      coursewareScore: '',
      coursewareFinishCount: '',
      coursewareSumCount: '',
    }
  },
  mounted() {
    this.getDetailsData()
    
    this.getCourseList()
  },
  methods: {
    getDetailsData(){
      let obj = {
        classId:this.classId,
        courseId: this.courseId,
        userId: this.userId
      }
      api.getAchievementCourseLearn(obj).then(rs=>{
        if(rs.code==0){
          this.courseProgress = rs.data.courseProgress;
          if(this.courseProgress > 100){
          	this.courseProgress = 100;
          }
          this.coursewareScore = Number(rs.data.coursewareScore)
          this.coursewareFinishCount = rs.data.coursewareFinishCount
          this.coursewareSumCount = rs.data.coursewareSumCount
        }else{
          this.$messageError(rs.msg)
        }
      })
      // this.$ajax.post('/api-study/scoremanage/courseware/learn',obj).then(rs=>{
      //   if(rs.data.code==0){
      //     this.courseProgress = Math.floor(rs.data.data.courseProgress);
      //     if(this.courseProgress > 100){
      //     	this.courseProgress = 100;
      //     }
      //     this.coursewareScore = Number(rs.data.data.coursewareScore.toFixed(1))
      //     this.coursewareFinishCount = rs.data.data.coursewareFinishCount
      //     this.coursewareSumCount = rs.data.data.coursewareSumCount
      //   }else{
      //     this.$messageError(rs.data.msg)
      //   }
      // })
    },
     getCourseList(){
       var url = `/${this.courseId}/${this.userId}/${this.classId}`
       console.log(url)
       api.getAchievementCourseList(url).then(rs=>{
             if(rs.code==0){
          let arr = []
          rs.data.forEach((v,i)=>{
            let obj = {
              catalogName: v.catalogName,
              resourceDtos: v.resourceDtos,
              level: 0,
              num: i+1
            }
            arr.push(obj)
            if(v.children.length>0){
              v.children.forEach(val=>{
                let obj = {
                  catalogName: val.catalogName,
                  resourceDtos: val.resourceDtos,
                  level: 1
                }
                arr.push(obj)
                if(val.children.length>0){
                  val.children.forEach(value=>{
                    let obj = {
                      catalogName: value.catalogName,
                      resourceDtos: value.resourceDtos,
                      level: 2
                    }
                    arr.push(obj)
                  })
                }
              })
            }
          })
          // this.treeData = rs.data.data
          this.treeData = arr
          console.log(arr)
        }else{
          this.$messageError(rs.msg)
        }
       })
      // this.$ajax.get('/api-course/catalog/catalog/v2/query/'+this.courseId+'/'+this.userId).then(rs=>{
      //   if(rs.data.code==0){
      //     let arr = []
      //     rs.data.data.forEach((v,i)=>{
      //       let obj = {
      //         catalogName: v.catalogName,
      //         resourceDtos: v.resourceDtos,
      //         level: 0,
      //         num: i+1
      //       }
      //       arr.push(obj)
      //       if(v.children.length>0){
      //         v.children.forEach(val=>{
      //           let obj = {
      //             catalogName: val.catalogName,
      //             resourceDtos: val.resourceDtos,
      //             level: 1
      //           }
      //           arr.push(obj)
      //           if(val.children.length>0){
      //             val.children.forEach(value=>{
      //               let obj = {
      //                 catalogName: value.catalogName,
      //                 resourceDtos: value.resourceDtos,
      //                 level: 2
      //               }
      //               arr.push(obj)
      //             })
      //           }
      //         })
      //       }
      //     })
      //     // this.treeData = rs.data.data
      //     this.treeData = arr
      //   }else{
      //     this.$messageError(rs.data.msg)
      //   }
      // })
    
    },
    changeCellStyle(row, column, rowIndex, columnIndex) {
      if(row.columnIndex === 1){
        return 'background: rgba(83,151,247,0.05)'
      }else{
        return ''
      }
    }
  },
}
</script>
<style lang="scss">
  .courseware_learning_wrap{
    .courseware_learning_title{
      height:40px;
      border:1px solid rgba(226,226,226,1);
      border-radius:4px;
      display: flex;
      align-items: center;
      span{
        font-size: 12px;
        color: #333;
        b{
          font-weight: 400;
          color: #5397f7;
        }
      }
      i{
        margin: 0 5px;
      }
    }
    .courseware_learning_chapter{
      margin-bottom: 16px;
      h2{
        font-size:16px;
        font-weight: 600;
        color:rgba(51,51,51,1);
        line-height: 50px;
      }
      .el-table{
        .cell{
          padding: 0;
          position: relative;
        }
        .source_list{
          li{
            display: flex;
            align-items: center;
            padding-left:40px;
            line-height: 40px;
            border-bottom: 1px solid #E2E2E2;
            min-height: 40px;
            &:last-child{
              border-bottom: none;
            }
            img{
              height: 24px
            }
            span{
              display: inline-block;
              width: 80%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #666666;
              margin-left: 8px;
              text-align: left;
            }
          }
        }
        .progress_list{
          li{
            line-height: 40px;
            border-bottom: 1px solid #E2E2E2;
            div{
              display: flex;
              align-items: center;
              justify-content: center;
              img{
                height: 16px;
              }
            }
          }
        }
        .el-table__row{
          &:nth-child(3n+1){
            td{
              &:first-child{
                border-left: 3px solid #5397F7;
              }
            }
          }
          &:nth-child(3n+2){
            td{
              &:first-child{
                border-left: 3px solid #34D3B0;
              }
            }
          }
          &:nth-child(3n+3){
            td{
              &:first-child{
                border-left: 3px solid #FFB23C;
              }
            }
          }
        }
        .level_zero_img{
          width: 16px;
          height: 16px;
          position: absolute;
          left: 18px;
          top: 0;
          bottom: 0;
          margin: auto;
        }
        .level_zero_num{
          font-size: 14px;
          font-weight: 600;
        }
        .level_zero{
          font-size: 14px;
          font-weight: 600;
        }
        .level_one{
          color: #666;
          margin-left: 10px;
          position: relative;
          &::after{
            content: '';
            position: absolute;
            left: -13px;
            top: 7px;
            width: 0;
            height: 0;
            border: 4px solid transparent;
            border-top-color: #666;
          }
        }
        .level_two{
          color: #666;
          margin-left: 30px;
          position: relative;
          &::after{
            content: '';
            position: absolute;
            left: -13px;
            top: 7px;
            width: 0;
            height: 0;
            border: 4px solid transparent;
            border-top-color: #666;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/achievement/teacher/coursewareLearning.vue